module.exports = __webpack_public_path__ + "img/stats.2473674e.gif";